import { Link } from "react-router-dom";
import { morePageData } from "../../assets/navbarData";
import { iconMap } from "../../components/IconMap";
import { LogOutIcon } from "lucide-react";
import { useAppDispatch } from "../../hooks";
import { logout } from "../../slices/authSlice";


const MorePage = () => {

    const dispatch = useAppDispatch();

    return ( 
        <div className="flex flex-col w-full h-screen text-lg p-4 gap-4">
            {morePageData.map((item) => (
                <Link
                    to={item.route}
                    key={item.route}
                    className="flex items-center gap-3 p-4 rounded-lg transition bg-white 
                    border border-primary text-primary shadow hover:shadow-md hover:border-blue-900"
                >
                    <span>{iconMap[item.icon]}</span>
                    <span className="font-medium">{item.name}</span>
                </Link>
            ))}

            <div 
                className="flex items-center gap-3 p-4 rounded-lg transition bg-white 
                border border-red-700 text-red shadow hover:shadow-md hover:border-red-900"
                onClick={() => dispatch(logout())}
            >
                <span><LogOutIcon size={22} /></span>
                <span>Log Out</span>
            </div>

        </div>
    );
}
 
export default MorePage;